module.exports = __webpack_public_path__ + "static/media/Zhongli.e699d7e2.png";